<ion-content class="system-popover-content">
  <div class="system-list">
    <div
      class="system-option"
      *ngFor="let sys of systems; trackBy: trackBySystemId"
      [class.selected]="sys.id === selectedSystemId"
      (click)="selectSystem(sys)">

      <div class="system-name">
        {{ sys.name }}
      </div>

      <div class="system-variant" *ngIf="sys.variant">
        {{ sys.variant | translate }}
      </div>
    </div>
  </div>
</ion-content>